import React, { Component } from "react";
import { connect } from "react-redux";
import ProductHeader from "../ProductDetails/ProductHeader";
import { CircularProgress, TextField, Button } from "@material-ui/core";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import PersonOutlined from "@material-ui/icons/PersonOutlined";
import LockOutlined from "@material-ui/icons/LockOutlined";
import instance from "../../store/actions/instance";
import { setUser } from "../../store/actions/auth";
import { Redirect } from "react-router";
import ActionButton from "../ActionButton";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import AppleAuth from "./AppleAuth";
import GoogleAuth from "./GoogleAuth";
import EmailAuth from "./EmailAuth";
import MuiPhoneNumber from "material-ui-phone-number";
import { isValidPhoneNumber } from "react-phone-number-input";

const isVirginPhoneNumber = (phone) => {
  // For Virgin Mobile Kuwait. Numbers are 8 digits long and start with 41
  if (!phone) return false;
  if (
    phone.startsWith("+965") &&
    phone.split("+965")[1].startsWith("41") &&
    phone.split("+965")[1].length === 8
  )
    return true;
  return false;
};

class index extends Component {
  state = {
    mode: !this.props.phone ? 0 : this.props.history.location?.state?.mode || 1,
    // email: this.props.email,
    password: "",
    errors: {},
    errorText: "",
    showPassword: false,
    verify: false,
    code: "",
    phoneFieldKey: Math.random() * 99999,
    phone: this.props.phone,
    countryDialCode: "",
  };

  submit = async () => {
    const { mode, phone, password } = this.state;
    const { language, settings } = this.props;
    let errors = { phone: false, password: false };
    if (
      (!isValidPhoneNumber(this.state.phone) &&
        !isVirginPhoneNumber(this.state.phone)) ||
      this.state.countryDialCode == this.state.phone.substring(1)
    ) {
      errors.phone = true;
    }

    if (!password.trim() || (password.trim().length < 8 && mode === 0)) {
      if (!password.trim()) errors.password = true;
      if (password.trim() && password.trim().length < 8 && mode === 0)
        errors.password = this.t("Minimum length is 8 characters");
    }
    if (errors.phone || errors.password) {
      this.setState({ errors: errors });
      return;
    }
    this.setState({ loading: true, errorText: "" });
    try {
      const res = await instance.post("/phone-auth/", {
        ...this.state,
        language: this.props.language,
      });
      //   const res = { data: { success: true, verify: true, token: "1" } };
      if (!res.data.success) {
        if (res.data.errors) this.setState({ errors: res.data.errors });
        if (res.data.message)
          this.setState({ errorText: this.t(res.data.message) });
      } else {
        if (res.data.verify) this.setState({ verify: true });
        else if (!this.props.auth.user) {
          await this.props.setUser(res.data.token, this.props.history);
          if (settings.enable_aseer_time) {
            window.location.reload();
          }
        }
      }
    } catch (e) {
      console.error(e);
    }
    this.setState({ loading: false });
  };

  verify = async () => {
    const { code } = this.state;

    let errors = { code: false };
    if (!code.trim()) {
      errors.code = this.t("Please enter verification code");
    } else if (code.length !== 6) {
      errors.code = this.t("Invalid verification code");
    }
    if (errors.code) {
      this.setState({ errors: errors });
      return;
    }
    this.setState({ verifyLoading: true, errorText: "" });
    try {
      const res = await instance.post("/verify-phone/", this.state);
      if (!res.data.success) {
        if (res.data.message)
          this.setState({ errorText: this.t(res.data.message) });
      } else {
        if (!this.props.auth.user) {
          this.props.setUser(res.data.token, this.props.history);
        }
      }
    } catch (e) {
      console.error(e);
    }
    this.setState({ verifyLoading: false });
  };

  t = (text) => {
    const { language } = this.props;
    if (language === "english") return text;

    const trans = {
      "Sign up": "التسجيل",
      "Log in": "تسجيل الدخول",
      Phone: "رقم الهاتف",
      Password: "كلمة المرور",
      "Confirm password": "تأكيد كلمة المرور",
      "Already a user? LOGIN": "لديك حساب؟ اضغط لتسجيل الدخول",
      "Don't have an account? SIGN UP": "ليس لديك حساب؟ اضغط للتسجيل",
      "Invalid phone number": "رقم الهاتف غير صحيح",
      "Minimum length is 8 characters": "الحد الأدنى 8 احرف",
      "The two passwords don't match": "لا يوجد تطابق بكلمتي المرور",
      "This phone is already registered": "هذا الرقم مستخدم من قبل",
      "Invalid login credentials": "بيانات الدخول غير صحيحة. حاول مرة اخرى",
      "Forgot password?": "ارسل رمز تحقق",
      Register: "التسجيل",
      Login: "تسجيل الدخول",
      OR: "أو",
      "A SMS was sent to": "تم ارسال رسالة نصية الى",
      "with a 6 digit verification code. Please enter it below":
        "مع رمز تحقق مكون من 6 رموز. قم بإدخاله ادناه",
      "Invalid verification code": "رمز تحقق خاطئ",
      "Please enter verification code": "الرجاء ادخال رمز التحقق",
      "Confirmation code": "رمز التحقق",
      Verify: "اتمام التحقق",
      "Forgot password?": "نسيت كلمة المرور؟",
      "Send me an OTP": "ارسل رمز تحقق",
    };
    return trans[text] || text;
  };
  handleChange = (e, eventPhone) => {
    const { settings } = this.props;

    if (eventPhone) {
      this.setState({ countryDialCode: eventPhone.dialCode });
    }
    if (typeof e == "string") {
      if (e.startsWith("+" + eventPhone.dialCode)) {
        this.setState({ phone: e });
      } else {
        this.setState({ phoneFieldKey: Math.random() * 999999 });
      }
      if (e.length !== this.state.phone.length && this.state.errors?.phone)
        this.setState({ errors: { ...this.state.errors, phone: false } });
    } else {
      this.setState({ [e.target.name]: e.target.value });
    }
  };

  getOnlyCountries = () => {
    const { settings, countries, address } = this.props;
    const countryObj = countries?.find((c) => c?.id === address?.country);

    if (
      countryObj?.name === "Nigeria" ||
      (countries?.length === 1 && countries[0].name === "Nigeria") ||
      settings.currency_iso === "NGN"
    )
      return ["ng"];

    return settings.show_all_country_codes
      ? []
      : [
          "kw",
          "sa",
          "qa",
          "om",
          "ae",
          "bh",
          "sy",
          "lb",
          "jo",
          "eg",
          "us",
          "uk",
          "cn",
        ];
  };

  render() {
    const {
      language,
      auth,
      cart,
      cart_items,
      promo_items,
      customTexts,
      settings,
      countries,
      address,
      store,
    } = this.props;
    const totalCartLength = cart_items.length + promo_items.length;
    if (this.props.auth.user) return <Redirect to="/" />;

    const inputLabelStyle = {
      transformOrigin: language == "english" ? "top left" : "top right",
      right: language == "arabic" ? 0 : "unset",
      left: language == "english" ? 0 : "unset",
    };
    const countryObj = countries?.find((c) => c?.id === address?.country);

    return (
      <div
        className="text-center"
        style={{ backgroundColor: "white", minHeight: "100vh" }}
      >
        <div className="free-space-70-white"></div>
        <ProductHeader
          onBack={() => {
            this.props.history.replace("/profile");
          }}
        />

        {!this.state.verify && (
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "50% 50%",
              columnGap: 7,
              padding: "0px 15px",
              //width: "calc(100% - 10px)",
              direction: language === "arabic" ? "rtl" : "ltr",
              justifyContent: "center",
            }}
          >
            <div
              style={{
                height: 40,
                border: "1px solid #0099cc",
                color: this.state.mode === 1 ? "white" : "#0099cc",
                width: "100%",
                borderRadius: 5,
                display: "grid",
                justifyContent: "center",
                alignContent: "center",
                cursor: "pointer",
                background: this.state.mode === 1 ? "#0099cc" : "transparent",
              }}
              onClick={() => this.setState({ mode: 1, errorText: "" })}
            >
              {this.t("Login")}
            </div>
            <div
              style={{
                height: 40,
                border: "1px solid #0099cc",
                color: this.state.mode === 0 ? "white" : "#0099cc",
                width: "100%",
                borderRadius: 5,
                display: "grid",
                justifyContent: "center",
                alignContent: "center",
                cursor: "pointer",
                background: this.state.mode === 0 ? "#0099cc" : "transparent",
              }}
              onClick={() => this.setState({ mode: 0, errorText: "" })}
            >
              {this.t("Register")}
            </div>
          </div>
        )}
        <div>
          <p
            style={{
              fontWeight: "bold",
              fontSize: 20,
              marginTop: 30,
              padding: "0px 15px",
              color: "#666",
            }}
            className={language === "arabic" ? "text-right" : "text-left"}
          >
            {this.state.mode === 0 ? this.t("Register") : this.t("Login")}{" "}
            {!!this.state.errorText && (
              <span style={{ color: "red", fontWeight: "bold", fontSize: 14 }}>
                - {this.state.errorText}
              </span>
            )}
          </p>

          {!this.state.verify ? (
            <div style={{ padding: "0px 15px" }}>
              <MuiPhoneNumber
                defaultCountry={
                  countryObj?.dial_code || store.default_dial_code || "kw"
                }
                onlyCountries={this.getOnlyCountries()}
                excludeCountries={["il"]}
                countryCodeEditable={false}
                disableAreaCodes={true}
                error={this.state.errors.phone}
                label={language == "english" ? "Phone *" : "رقم الهاتف *"}
                className=""
                color={"#0099cc"}
                autoComplete="tel"
                onChange={this.handleChange}
                key={this.state.phoneFieldKey}
                value={this.state.phone}
                fullWidth
                helperText={
                  this.state.phoneError
                    ? language == "english"
                      ? "Please enter your phone number"
                      : "الرجاء ادخال رقم الهاتف"
                    : ""
                }
                FormHelperTextProps={{
                  style: {
                    textAlign: language == "arabic" && "right",
                    marginRight: language == "arabic" && 5,
                  },
                }}
                InputLabelProps={{
                  style: inputLabelStyle,
                  dir: language == "english" ? "ltr" : "rtl",
                }}
              />

              <TextField
                fullWidth
                label={this.t("Password")}
                className={"my-4"}
                required
                type={this.state.showPassword ? "text" : "password"}
                onChange={(e) =>
                  this.setState({
                    password: e.target.value,
                    errors: { ...this.state.errors, password: false },
                    errorText: "",
                  })
                }
                error={!!this.state.errors.password}
                helperText={
                  typeof this.state.errors.password === "string"
                    ? this.state.errors.password
                    : undefined
                }
                InputLabelProps={{
                  style: inputLabelStyle,
                  dir: language === "english" ? "ltr" : "rtl",
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    this.submit();
                  }
                }}
                InputProps={{
                  dir: language === "english" ? "ltr" : "rtl",
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() =>
                          this.setState({
                            showPassword: !this.state.showPassword,
                          })
                        }
                        edge="end"
                      >
                        {this.state.showPassword ? (
                          <Visibility />
                        ) : (
                          <VisibilityOff />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                FormHelperTextProps={{
                  style: {
                    textAlign: language == "arabic" && "right",
                    marginRight: language == "arabic" && 5,
                  },
                }}
              />

              {this.state.mode === 1 && (
                <div
                  style={{
                    textAlign: language === "arabic" ? "left" : "right",
                    direction: language === "arabic" ? "rtl" : "ltr",
                  }}
                >
                  <span
                    onClick={() =>
                      this.props.history.push(
                        "/profile/forgot-password-phone",
                        {
                          phone: this.state.phone,
                        }
                      )
                    }
                  >
                    {this.t("Forgot password?")}
                  </span>
                  <Button
                    variant="text"
                    onClick={() =>
                      this.props.history.push(
                        "/profile/forgot-password-phone",
                        {
                          phone: this.state.phone,
                        }
                      )
                    }
                    style={{ color: "#0099cc" }}
                  >
                    {this.t("Send me an OTP")}
                  </Button>
                </div>
              )}
            </div>
          ) : (
            <div style={{ padding: "0px 15px" }}>
              <p style={{ direction: language === "arabic" ? "rtl" : "ltr" }}>
                {this.t("A SMS was sent to")}{" "}
                <span style={{ fontWeight: "bold" }}>{this.state.phone}</span>{" "}
                {this.t(
                  "with a 6 digit verification code. Please enter it below"
                )}
              </p>{" "}
              <TextField
                fullWidth
                label={this.t("Confirmation code")}
                required
                value={this.state.code.toLowerCase()}
                onChange={(e) =>
                  this.setState({
                    code: e.target.value,
                    errors: {},
                    errorText: "",
                  })
                }
                error={!!this.state.errors.code}
                helperText={
                  typeof this.state.errors.code === "string"
                    ? this.state.errors.code
                    : undefined
                }
                InputLabelProps={{
                  style: inputLabelStyle,
                  dir: language === "english" ? "ltr" : "rtl",
                }}
                InputProps={{
                  dir: language === "english" ? "ltr" : "rtl",
                  style: { textTransform: "lowercase" },
                }}
                FormHelperTextProps={{
                  style: {
                    textAlign: language == "arabic" && "right",
                    marginRight: language == "arabic" && 5,
                  },
                }}
              />
              <Button
                variant="contained"
                className="my-4"
                style={{
                  backgroundColor: "#0099cc",
                  color: "white",
                  width: 250,
                  height: 50,
                }}
                size="large"
                disableElevation
                onClick={() => this.verify()}
              >
                {!this.state.verifyLoading ? (
                  <span className="bold">{this.t("Verify")}</span>
                ) : (
                  <span>
                    <CircularProgress
                      style={{ width: 30, height: 30, color: "white" }}
                    />
                  </span>
                )}
              </Button>
            </div>
          )}
        </div>

        <p
          style={{
            color: "#999",
            marginTop: 40,
            fontSize: 18,
          }}
        >
          <span style={{ letterSpacing: -3, margin: "0px 10px" }}>
            --------------------
          </span>
          <span style={{ fontWeight: "bold" }}>{this.t("OR")}</span>
          <span style={{ letterSpacing: -3, margin: "0px 10px" }}>
            --------------------
          </span>
        </p>

        <h2
          classname="bold"
          style={{
            fontSize: 20,
            color: "#666666",
            textAlign: language === "arabic" ? "right" : "left",
            padding: "0px 15px",
            marginTop: 50,
            fontFamily: "Quicksand, Cairo",
          }}
        >
          {language == "english" ? "Login with" : "تسجيل الدخول بواسطة"}{" "}
        </h2>

        <List
          disablePadding
          dense
          component="nav"
          aria-label="Nav"
          style={{ direction: language == "english" ? "ltr" : "rtl" }}
        >
          <Divider />

          <EmailAuth history={this.props.history} language={language} />
          <AppleAuth history={this.props.history} language={language} />
          {(this.props.promise.src === "web" ||
            settings.enable_google_login_on_app) && (
            <GoogleAuth history={this.props.history} language={language} />
          )}
        </List>

        {!this.state.verify && (
          <ActionButton
            action={
              <>
                {!this.state.loading ? (
                  <span className="bold">
                    {this.state.mode === 0
                      ? this.t("Register")
                      : this.t("Login")}
                  </span>
                ) : (
                  <span>
                    <CircularProgress
                      style={{ width: 30, height: 30, color: "white" }}
                    />
                  </span>
                )}
              </>
            }
            onClick={() => this.submit()}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    cart: state.cart,
    language: state.store.language,
    auth: state.auth,
    settings: state.store.store.settings,
    cart_items: state.cart.cart,
    promo_items: state.cart.promo_items,
    customTexts: state.store.store.settings.custom_texts,
    branch: state.branch,
    address: state.customers?.address,
    pages: state.staticPages.pages,
    store: state.store.store,
    promise: state.promise,
    countries: state.store.store.all_countries || state.store.store.countries,
    phone: state.customers?.customerContact?.phone || "",
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setUser: (key, history) => dispatch(setUser(key, history)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(index);
